import React from "react";
import { Outlet } from "react-router-dom";
import Banner from "./banner/Banner";
import Navbar from "./navbar/Navbar";
import Footer from "./footer/Footer";
import SharePage from "../common/SharePage/SharePage";
import StafSidebar from "./StaffSidebar/StafSidebar";
import UserSideBar from "./user-sidebar/UserSideBar";
import { useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.min.css";
import { toast, ToastContainer } from "react-toastify";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import BackButton from "../common/backbutton/BackButton";

const Layout = () => {
  const { user, isSuccess } = useSelector((state) => state.auth);


  useEffect(() => {
    isSuccess && user && toast.success("User login sucessfully");
  }, [user, isSuccess]);

  let isStaffLogin = false;
  let isClientLogin = false;
  user &&
    (user.user_type === "CL" ? (isClientLogin = true) : (isStaffLogin = true));

  return (
    <div className="">
                <Helmet>
<title>Graphic Marg</title>
<meta name='description' content=' A complete solution for Company' />
<meta property="og:description"   content="A complete solution for Company" />

</Helmet>
      <ToastContainer theme = "colored" />

      <div className="sticky  top-0 z-50">
        <Banner />
        <Navbar />
      </div>

      <div className="w-full">
        <div className="max-w">
          <div className="">
            <div className="grid grid-cols-12">
              <div className={`col-span-1 ${isStaffLogin && "hidden"}`}>
               
               <div className="hidden md:block"> <BackButton /> </div>
                <SharePage />


              </div>

              {user && (
                <>
                  {isStaffLogin && (
                    <div className="xl:col-span-2">
               <div className="hidden md:block"> <BackButton /> </div>
                      
                      
                      <StafSidebar />
                    </div>
                  )}
                  {isClientLogin && (
                    <div className="xl:col-span-2">
                      <UserSideBar />
                    </div>
                  )}
                </>
              )}

              <div
                className={`col-span-12 lg:col-span-11 ${isStaffLogin
                  && "xl:col-span-10"}

                  ${isClientLogin && "xl:col-span-9"

                  } `}
              >
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Layout;
